import { z } from "zod";

export const CreateSalonAppointmentFormSchema = z.object({
  employee: z.string().uuid({ message: "Colaborador(a) inválido" }),
  clientNumber: z
    .string()
    .regex(/^55\d{11}$/, { message: "Número de cliente inválido" }),
  datetime: z.date({ message: "Data inválida" }),
  service: z.string({ message: "Serviço inválido" }),
});
